import { WalletConfig } from "../../services/api";

 
export const merge = <T>(obj1: T, obj2: Partial<T>): T => {
  if (!obj1 || !obj2) return obj1 || obj2 as T;

  const result = { ...(obj1 as any) };

  Object.entries(obj2).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (typeof value === "object" && !Array.isArray(value) && value !== null) {
      if (result[key] && typeof result[key] === "object" && !Array.isArray(result[key])) {
        result[key] = merge(result[key], value);
        return;
      }
    }

    result[key] = value;
  });

  return result as T;
};

const NULLABLE_POSTER_COLORS = ["footerBackgroundColor", "labelColor"] as const;

/**
 * Like `merge`, but a `null` Poster colour in the override clears the inherited value,
 * which is how a tier switches back to Wallet's automatic footer or default label colour.
 */
export const mergeWalletConfig = (base: WalletConfig, override: Partial<WalletConfig>): WalletConfig => {
  const merged = merge(base, override);
  const posterOverride = override?.ios?.poster;
  const clearedKeys = NULLABLE_POSTER_COLORS.filter(key => posterOverride?.[key] === null);
  if (!clearedKeys.length || !merged?.ios?.poster) return merged;

  const poster = { ...merged.ios.poster };
  clearedKeys.forEach(key => delete poster[key]);
  return { ...merged, ios: { ...merged.ios, poster } };
};
